import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

type PriceDropBadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  percentage: number;
};

export const PriceDropBadge = ({ percentage, className, ...rest }: PriceDropBadgeProps) => {
  const { t } = useTranslation();
  const value = `${percentage}%`;
  const label = t('common.off', { percentage });
  const at = label.indexOf(value);

  return (
    <span {...rest} className={classNames('price-drop-badge', className)} data-testid="price-drop-badge">
      <span>
        {at < 0 ? (
          label
        ) : (
          <>
            {label.slice(0, at)}
            <strong>{value}</strong>
            {label.slice(at + value.length)}
          </>
        )}
      </span>
    </span>
  );
};
